import {Panes, TextField} from '@management-ui/core';
import React from 'react';
import YesNoField from '../../../../components/YesNoField';

const Fields = ({location = {}, prefix = ''}) => {
  return (
    <Panes
      entity={location}
      prefix={prefix}
      panes={[
        {
          title: 'Contact Location',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name'}}
            />,
            <TextField
              name="address1"
              prefix={prefix}
              label="Address Line 1"
            />,
            <TextField
              name="address2"
              prefix={prefix}
              label="Address Line 2"
            />,
            <TextField
              name="town"
              prefix={prefix}
              label="Town / City"
            />,
            <TextField
              name="region"
              prefix={prefix}
              label="Region / County"
            />,
            <TextField
              name="postcode"
              prefix={prefix}
              label="Postcode"
            />,
            <TextField
              name="country"
              prefix={prefix}
              label="Country"
            />,
            <YesNoField
              name="is_invoicing"
              prefix={prefix}
              label="Is this the invoicing address?"
            />,
          ]
        }
      ]}
      title=""/>
  );
};

export default Fields;
